import tagApi from "@/api/tag";

export default {
  actions: {
    async create({ dispatch }, data) {
      await tagApi.createTag(data);
      await dispatch("fetchList", data.serviceAreaId);
    },
    async delete({ commit }, params) {
      const { id, serviceAreaId } = params;
      await tagApi.delete(id, serviceAreaId);
    },
    async getTag({ commit }, params) {
      const { id, serviceAreaId } = params;
      const tag = await tagApi.getTagById(id, serviceAreaId);

      return commit("setTag", tag);
    },
    async fetchList({ commit }, serviceAreaId) {
      commit("setTagListIsLoading", true);
      const list = await tagApi.list(serviceAreaId);

      commit("setTagListIsLoading", false);
      commit("setList", list);
    },
    async update({ dispatch }, data) {
      await tagApi.update(data);
      await dispatch("getTag", data);
    },
  },
  mutations: {
    setEdit(state, tag) {
      state.edit = tag;
    },
    setList(state, list) {
      state.list = list;
    },
    setTag(state, tag) {
      state.record = tag;
    },
    setTagListIsLoading(state, isLoading) {
      state.isLoadingTagList = isLoading;
    },
  },
  namespaced: true,
  state: {
    edit: {},
    list: [],
    record: {},
    isLoadingTagList: false,
  },
};
